<form (ngSubmit)="createEngine()" [formGroup]="createForm" class="createForm drop-padding">
  <mat-form-field appearance="outline">
    <mat-label>Название</mat-label>
    <input matInput placeholder="Название" formControlName="description" />
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Обьем см³</mat-label>
    <input matInput placeholder="Обьем см³" formControlName="capacity" />
  </mat-form-field>
  <app-manufacturer-selector [control]="manufacturerControl"></app-manufacturer-selector>
  <mat-form-field appearance="outline">
    <mat-label>Лошадиные силы</mat-label>
    <input
      matInput
      placeholder="Лошадиные силы"
      (input)="horsePowerChange()"
      formControlName="horsePower"
    />
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Киловаты</mat-label>
    <input matInput placeholder="Киловаты" (input)="kwChange()" formControlName="kW" />
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Тип топлива</mat-label>
    <mat-select formControlName="fuelType">
      <mat-option [value]="fuelType.GASOLINE"> Бензин </mat-option>
      <mat-option [value]="fuelType.DIESEL"> Дизель </mat-option>
      <mat-option [value]="fuelType.HYBRID"> Гибрид </mat-option>
      <mat-option [value]="fuelType.ELECTRIC"> Электричество </mat-option>
      <mat-option [value]="fuelType.METHAN"> Метан </mat-option>
      <mat-option [value]="fuelType.LPG"> Пропан </mat-option>
    </mat-select>
  </mat-form-field>
  <button mat-flat-button color="primary">Сохранить</button>
</form>
